import React from 'react';
import styles from './Footer.scss';

const SocialBlock = () => {
  return (
    <div className={styles.footerSocialMedia}>
      <a href="https://www.facebook.com/Onthehouse.com.au/" title="Facebook" target="_blank" rel="nofollow noopener noreferrer">
        <i className={'icon ' + styles.iconFacebook}></i>
      </a>
      <a href="https://twitter.com/onthehouse_au" title="Twitter" target="_blank" rel="nofollow noopener noreferrer">
        <i className={'icon ' + styles.iconTwitter}></i>
      </a>
      <a href="https://www.youtube.com/user/onthehouseAU" title="Youtube" target="_blank" rel="nofollow noopener noreferrer">
        <i className={'icon ' + styles.iconYoutube}></i>
      </a>
      <a href="https://www.pinterest.com.au/onthehouseau/" title="Pinterest" target="_blank" rel="nofollow noopener noreferrer">
        <i className={'icon ' + styles.iconPinterest}></i>
      </a>
    </div>
  );
};

export default SocialBlock;
